import React from "react";
import "./navbar.style.sass";
import logo from "../../assets/image/logoWeb1.png";
import { Icon, Nav } from "rsuite";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { ChangeActiveLink } from "../../redux/site/site.actions";
import { selectActiveLink } from "../../redux/site/site.selector";
import { createStructuredSelector } from "reselect";
import NavStrip from "../../components/navStrip/navStrip.component";
import { Badge } from "rsuite";
import {
  selectCartItemCount,
  selectProduct,
} from "../../redux/users/users.selector";
import { withRouter } from "react-router-dom";
import SiteTypes from "../../redux/site/site.types";

class NavBar extends React.Component {
  // componentDidUpdate(prevProps) {
  //     const {history, active} = this.props;
  //     if(prevProps.active !== active){
  //         if(active === 'home'){
  //             history.push('/');
  //             window.addEventListener("load", ()=>this.props.changeLoad())
  //         }else if(active === 'tracking') {
  //             window.location.href='https://gps.xitonix.com'
  //         } else {
  //             history.push(`/${active}`)
  //         }
  //     }
  // }

  render() {
    const { active, changeActive, itemCount, basket, history } = this.props;
    return (
      <div className="navbar-main">
        <div className="logo-area">
          <Link to="/" onClick={() => changeActive("home")}>
            <img src={logo} alt="Xitonix" />
            <p>نسل جدید امنیت</p>
          </Link>
        </div>
        <div className="link-area">
          <Nav
            activeKey={active}
            onSelect={(activeKey) => {
              changeActive("checkout");
              history.push("/checkout");
            }}
          >
            <Nav.Item eventKey="checkout">
              <Badge content={basket.length ? itemCount : false}>
                <Icon icon="shopping-cart" />
              </Badge>
            </Nav.Item>
          </Nav>
        </div>
        <div className="responsive-shopIcon">
          <div
            className="responsive-shopIcon-div"
            onClick={() => {
              changeActive("checkout");
              history.push("/checkout");
            }}
          >
            <Badge content={basket.length ? itemCount : false}>
              <Icon icon="shopping-cart" style={{ cursor: "pointer" }} />
            </Badge>
          </div>
        </div>
        <div className="nav-strip">
          <NavStrip />
        </div>
      </div>
    );
  }
}

const mapStateToProps = createStructuredSelector({
  active: selectActiveLink,
  basket: selectProduct,
  itemCount: selectCartItemCount,
});
const mapDispatchToProps = (dispatch) => ({
  changeActive: (activeKey) => dispatch(ChangeActiveLink(activeKey)),
  changeLoad: () => dispatch({ type: SiteTypes.LOADED }),
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(NavBar));
